import type { FeedbackArea } from './types';

/**
 * The only thing the lightbulb carries to the Feedback Center: one value from a fixed list,
 * derived from the SECTION of the current path. Never the URL, a query string, an id or a token.
 */
export function areaForPath(pathname: string): FeedbackArea | null {
  const [section, ...rest] = pathname.replace(/^\/app\/?/, '').split('/');
  switch (section) {
    case '':
      return 'home';
    case 'boards':
      return 'boards';
    case 'databases':
      return 'databases';
    case 'calendar':
    case 'my-tasks':
      return 'calendars';
    case 'workspaces':
      return rest[1] === 'calendar' ? 'calendars' : 'workspaces';
    case 'browse':
      return rest[0] === 'boards'
        ? 'boards'
        : rest[0] === 'databases'
          ? 'databases'
          : rest[0] === 'workspaces'
            ? 'workspaces'
            : 'home';
    case 'settings':
    case 'account':
      return 'settings';
    default:
      return null;
  }
}
